export class InternalAnalyticsService {
  client: any;
  constructor({client}: any) {
    this.client = client;
  }
  sendEvent(params) {
    return this.client.post(`api/v2/attribution`, params);
  }
}
